goog.module('yext.m4.confcode.adminconsole.Constants');

/**
 * Defines the constants to be used in the admin console.
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */

const resourceTypeToDisplayName = {
  'answers': 'Answers',
  'cloudstream': 'Cloudstream',
  'crawler': 'Crawler',
  'graph': 'Graph Merge',
  'km': 'Knowledge Manager',
  'pages': 'Pages',
  'platform': 'Platform',
  'schema': 'Schematopia',
  'analytics': 'Analytics',
  'streams': 'Streams',
  'listings': 'Listings',
  'chat': 'Chat',
  'reviews': 'Reviews',
};

exports = {
  resourceTypeToDisplayName,
};
